module.exports = __webpack_public_path__ + "static/media/zoo-boom.00bfa9be.jpg";